<template lang="pug">
div
  div.filter-type.is-flex(v-if="(!isLoading && list.length > 0) || filterSelected")
    span.title-tag 
      span Filter by type:
    .flex-1
      .tag(
        v-for="o in filterTypes"
        :class="{'selected': o.selected}"
        @click="selectTypeFilter(o)"
      ) {{ o.name }}
  div.events-super-container(:style="'max-height: ' + maxHeightStyle")
    .box-shadow-container.top.box-shadow-container-top(v-show="showTopShadow")
    .info-miner.w100.event-container#event-container(:class="{'infinite-container': infiniteScroll}" :style="'max-height: ' + maxHeightStyle")
      .result-no-payments.pos-r.padding-no-results.has-text-left(v-if="!isLoading && list.length === 0")
        span(v-if="filterSelected") There are no events with the current filters.
        span(v-else) You have no live updating data, yet.
      .live-list
        .live-item(v-for="item, index in list" :class="{'animate-long': item.updated}")
          .live-icon 
            i.fa(:class="item.icon" :style="{color: item.iconColor}")
          .live-description
            template(v-if="item.version == 2")
              template(v-if="item.type == 'reward'")
                .amount-large
                  template(v-if="item.amount_extended")
                    span {{ item.amount }}
                    span.extended_amount {{ item.amount_extended.replace(item.amount, '') }} 
                  template(v-else)
                    span {{ item.amount }} 
                  img(:src="coinLogo", :alt="coin + ' logo'")
                .reward-desc
                  span Received over the past {{ item.time_diff | toMinutes }} minutes 
                  .is-hidden-tablet-only.is-hidden-desktop-only.is-hidden-widescreen-only.is-hidden-fullhd {{ item.time_info }}
                  span.is-hidden-mobile.hint--top(:aria-label="item.time_info")
                    |  
                    i.fa.fa-info-circle
            template(v-else)
              span(v-html="item.description")
            .live-date
              span.w100.s12 {{ item.timestamp | formatDateSecond }}
          .live-external-link(v-if="item.type !== 'reward'" @click="goToEvent(item)")
            i.fa.fa-external-link-square
      .fs-13.text-white-on-dark.has-text-centered.is-loading(v-if="isLoading && !isLoadingParent") Loading...
      .more-events.has-text-centered(v-if="!isLoading && !infiniteScroll && list.length > 0 && !noMoreFetch")
        div.info-link(@click="loadMoreEvents")
          span View more events
        span.more-events-subtitle Events are kept for up to 7 days
    .box-shadow-container.bottom.box-shadow-container-bottom(v-show="showBottomShadow")

</template>

<script>
import dayjs from 'dayjs'
import { apiGet } from '../util/general'
export default {
  name: 'c_tab_live_event',
  props: ['uuid', 'summary', 'isLoadingParent'],
  data() {
    return {
      list: [],
      isLoading: true,
      continueLoading: false,
      infiniteScroll: false,
      containerHeight: 0,
      showTopShadow: false,
      showBottomShadow: false,
      noMoreFetch: false,
      isHoveringTop: false,
      isHoveringBottom: false,
      isDown: false,
      startY: 0,
      scrollTop: 0,
      scrollMovement: 10,
      dictionary: {
        'reward': {
          icon: 'fa-arrow-circle-o-up',
          iconColor: '#9be122',
          template: `Your balance has increased by <b>{{amount}} {{coin}}</b>`
        },
        'worker-offline': {
          icon: 'fa-user-times',
          iconColor: '#f9eb6c',
          template: `Worker <b>{{workerName}}</b> is now offline ({{algorithm}})`
        },
        'worker-online': {
          icon: 'fa-user-plus',
          iconColor: '#9bee81',
          template: `Your worker <b>{{workerName}}</b> is now online ({{algorithm}})`
        },
        'payout-success': {
          icon: 'fa-paper-plane',
          iconColor: '#77d8e6',
          template: `Your payment of <b>{{amount}} {{coin}}</b> is now complete.`
        },
        'payout-processing': {
          icon: 'fa-paper-plane-o',
          iconColor: '#77d8e6',
          template: `Your payment of <b>{{amount}} {{coin}}</b> is being processed!`
        },
        'payout-pending': {
          icon: 'fa-paper-plane-o',
          iconColor: '#919191',
          template: `A payment of <b>{{amount}} {{coin}}</b> have been initiated!`
        },
        'payout-error': {
          icon: 'fa-paper-plane',
          iconColor: '#e67777',
          template: `Your payment of <b>{{amount}} {{coin}}</b> failed.`
        }
      },
      page: 1,
      hasNext: false,
      hasPrev: false,
      filterTypes: [
        {
          code: 'worker',
          name: 'Workers',
          selected: false
        },
        {
          code: 'reward',
          name: 'Rewards',
          selected: false
        },
        {
          code: 'payout',
          name: 'Payouts',
          selected: false
        }
      ],
      isMobile: false
    }
  },
  computed: {
    coinLogo() {
      return this.$store.getters.coinData.logo
    },
    coin() {
      return this.$store.getters.coin
    },
    maxHeightStyle() {
      let vm = this
      if (vm.infiniteScroll && !vm.isMobile) {
        return vm.containerHeight + 'px;'
      } else {
        return 'fit-content;'
      }
    },
    filterSelected() {
      let vm = this
      return (vm.filterTypes.filter(o => o.selected).map(o => o.code)).length > 0
    },
    liveFilter() {
      return this.$store.getters.liveFilter
    }
  },
  async mounted() {
    let vm = this

    let filterTypeCodesSelected = vm.liveFilter
    if (filterTypeCodesSelected) {
      for (var i = 0; i < vm.filterTypes.length; i++) {
        if (filterTypeCodesSelected.includes(vm.filterTypes[i].code)) vm.filterTypes[i].selected = true
      }
    }

    window.addEventListener('scroll', vm.checkMobileBottomScroll)

    let container = document.getElementById('event-container')
    container.addEventListener('scroll', vm.reprintShadowScroll)
    window.addEventListener('resize', vm.reprintShadowScroll);

    let boxShadowScrollLeft = document.getElementsByClassName('box-shadow-container-top')[0]
    let boxShadowScrollRight = document.getElementsByClassName('box-shadow-container-bottom')[0]

    boxShadowScrollLeft.addEventListener('click', (e) => {
      vm.isHoveringBottom = false
      vm.isHoveringTop = true
      vm.doScroll('top', vm.scrollMovement * 8)
      vm.isHoveringTop = false
    });

    boxShadowScrollLeft.addEventListener('mouseover', (e) => {
      if (!vm.isTouchEvent()) {
        vm.isHoveringBottom = false
        vm.isHoveringTop = true
        vm.doScroll('top', vm.scrollMovement)
      }
    });

    boxShadowScrollLeft.addEventListener('mouseout', (e) => {
      vm.isHoveringTop = false
    });

    boxShadowScrollRight.addEventListener('mouseover', (e) => {
      if (!vm.isTouchEvent()) {
        vm.isHoveringTop = false
        vm.isHoveringBottom = true
        vm.doScroll('bottom', vm.scrollMovement)
      }
    });

    boxShadowScrollRight.addEventListener('mouseout', (e) => {
      vm.isHoveringBottom = false
    });

    boxShadowScrollRight.addEventListener('click', (e) => {
      vm.isHoveringTop = false
      vm.isHoveringBottom = true
      vm.doScroll('bottom', vm.scrollMovement * 8)
      vm.isHoveringBottom = false
    });

    container.addEventListener('mousedown', (e) => {
      vm.isDown = true;
      vm.startY = e.pageY - container.offsetTop;
      vm.scrollTop = container.scrollTop;
    });
    container.addEventListener('mouseleave', () => {
      vm.isDown = false;
    });
    container.addEventListener('mouseup', () => {
      vm.isDown = false;
    });
    container.addEventListener('mousemove', (e) => {
      if (!vm.isDown) return;
      e.preventDefault();
      vm.isHoveringTop = false
      vm.isHoveringBottom = false
      const x = e.pageY - container.offsetTop;
      const walk = (x - vm.startY) * 1; // scroll-normal
      container.scrollTop = vm.scrollTop - walk;
    });
  },
  beforeUnmount() {
    let vm = this

    window.removeEventListener('scroll', vm.checkMobileBottomScroll)

    let container = document.getElementById('event-container')
    container.removeEventListener('scroll', vm.reprintShadowScroll)
    window.removeEventListener('resize', vm.reprintShadowScroll);

    let boxShadowScrollLeft = document.getElementsByClassName('box-shadow-container-top')[0]
    let boxShadowScrollRight = document.getElementsByClassName('box-shadow-container-bottom')[0]

    boxShadowScrollLeft.removeEventListener('click', (e) => {
      vm.isHoveringBottom = false
      vm.isHoveringTop = true
      vm.doScroll('top', vm.scrollMovement * 8)
      vm.isHoveringTop = false
    });

    boxShadowScrollLeft.removeEventListener('mouseover', (e) => {
      if (!vm.isTouchEvent()) {
        vm.isHoveringBottom = false
        vm.isHoveringTop = true
        vm.doScroll('top', vm.scrollMovement)
      }
    });

    boxShadowScrollLeft.removeEventListener('mouseout', (e) => {
      vm.isHoveringTop = false
    });

    boxShadowScrollRight.removeEventListener('mouseover', (e) => {
      if (!vm.isTouchEvent()) {
        vm.isHoveringTop = false
        vm.isHoveringBottom = true
        vm.doScroll('bottom', vm.scrollMovement)
      }
    });

    boxShadowScrollRight.removeEventListener('mouseout', (e) => {
      vm.isHoveringBottom = false
    });

    boxShadowScrollRight.removeEventListener('click', (e) => {
      vm.isHoveringTop = false
      vm.isHoveringBottom = true
      vm.doScroll('bottom', vm.scrollMovement * 8)
      vm.isHoveringBottom = false
    });

    container.removeEventListener('mousedown', (e) => {
      vm.isDown = true;
      vm.startY = e.pageY - container.offsetTop;
      vm.scrollTop = container.scrollTop;
    });
    container.removeEventListener('mouseleave', () => {
      vm.isDown = false;
    });
    container.removeEventListener('mouseup', () => {
      vm.isDown = false;
    });
    container.removeEventListener('mousemove', (e) => {
      if (!vm.isDown) return;
      e.preventDefault();
      vm.isHoveringTop = false
      vm.isHoveringBottom = false
      const x = e.pageY - container.offsetTop;
      const walk = (x - vm.startY) * 1; // scroll-normal
      container.scrollTop = vm.scrollTop - walk;
    });
  },
  beforeDestroy() {
    let vm = this
    window.removeEventListener('scroll', vm.checkMobileBottomScroll)
  },
  methods: {
    addEvent(e) {
      let vm = this

      let filterTypeCodesSelected = vm.filterTypes.filter(o => o.selected).map(o => o.code)
      if (filterTypeCodesSelected.length > 0 && !filterTypeCodesSelected.includes(e.e)) return

      let item = vm.formatEventSocket(e)
      vm.list.unshift(item)
      if (!vm.infiniteScroll && vm.list.length > 10) vm.list.pop()

      setTimeout(function () {
        vm.list[0].updated = false
        item.updated = false
      }, 1310)
    },
    fetch(clear, cb) {
      let vm = this

      if ((!vm.isLoading && !vm.noMoreFetch) || clear || vm.continueLoading) {
        vm.isLoading = true
        if (clear && (!cb || typeof cb !== 'function')) vm.list = []

        if (clear) vm.page = 1
        else vm.page++

        let url = '/v5/account/' + vm.uuid + '/events'
        if (vm.page > 1) url += '?page=' + (vm.page || 1)

        let filterTypeCodesSelected = vm.filterTypes.filter(o => o.selected).map(o => o.code)
        if (filterTypeCodesSelected.length > 0) {
          if (vm.page > 1) url += '&'
          else url += '?'
          url += 'type=' + filterTypeCodesSelected.join(',')
        }

        let obj = {}
        apiGet(vm, url, obj, function (data) {
          if (!data.success) {
            vm.$store.dispatch('notifyError', data.msg)
          } else {
            vm.hasNext = data.data.has_next
            vm.hasPrev = data.data.has_prev
            for (var i = 0; i < data.data.list.length; i++) {
              let item = data.data.list[i]
              item = vm.formatEvent(item)
            }
            if (clear) {
              vm.list = data.data.list

              if (!cb || typeof cb !== 'function') vm.infiniteScroll = false
            } else {
              vm.list = [...vm.list, ...data.data.list]
            }

            if (!vm.hasNext) vm.noMoreFetch = true
            else vm.noMoreFetch = false

            if (cb && typeof cb === 'function') {
              vm.continueLoading = true
              cb()
            }
          }
        }, function (err) {
          console.error('Error:', err.message)
          vm.$store.dispatch('notifyError', err.message)
        }, function () {
          if (vm.continueLoading) vm.continueLoading = false
          else vm.isLoading = false
          setTimeout(function () {
            vm.reprintShadowScroll()
          }, 100)
        })
      }
    },
    formatEvent(item) {
      let vm = this
      item.version = item.data.version || 1
      if (item.event === 'reward') {
        item.type = item.event
        item.amount = item.data.amount
        if (item.data.amount_extended) item.amount_extended = item.data.amount_extended
        if (item.data.time_start && item.data.time_end) {
          item.time_info = `Between ${dayjs(item.data.time_start).format('HH:mm:ss')} and ${dayjs(item.data.time_end).format('HH:mm:ss')}`
          item.time_start = item.data.time_start
          item.time_end = item.data.time_end
          item.time_diff = item.data.time_end - item.data.time_start
        }
      } else if (item.event === 'worker') {
        if (item.data.online) item.type = 'worker-online'
        else item.type = 'worker-offline'
        item.algorithm = item.data.algorithm
        item.workerName = item.data.name
      } else if (item.event === 'payout') {
        if (item.data.code === 'success') item.type = 'payout-success'
        else if (item.data.code === 'processing') item.type = 'payout-processing'
        else if (item.data.code === 'pending') item.type = 'payout-pending'
        else if (item.data.code === 'error') item.type = 'payout-error'
        item.amount = item.data.amount
      }

      delete item.data

      item.coin = vm.coin
      item.icon = vm.dictionary[item.type].icon
      item.iconColor = vm.dictionary[item.type].iconColor
      item.updated = false
      if (item.algorithm) item.algorithm = item.algorithm.substring(0, 1).toUpperCase() + item.algorithm.substring(1, item.algorithm.length)
      item.description = vm.dictionary[item.type].template.replace(/\{\{(\w+)\}\}/g, function (_, key) {
        return item[key];
      });

      return item
    },
    formatEventSocket(item) {
      let vm = this
      item.version = item.d.v || 1
      if (item.e === 'reward') {
        item.type = item.e
        item.amount = item.d.a
        if (item.d.ae) item.amount_extended = item.d.ae
        if (item.d.ts && item.d.te) {
          item.time_info = `Between ${dayjs(item.d.ts).format('HH:mm:ss')} and ${dayjs(item.d.te).format('HH:mm:ss')}`
          item.time_start = item.d.ts
          item.time_end = item.d.te
          item.time_diff = item.d.te - item.d.ts
        }
      } else if (item.e === 'worker') {
        if (item.d.o) item.type = 'worker-online'
        else item.type = 'worker-offline'
        item.algorithm = item.d.a
        item.workerName = item.d.n
      } else if (item.e === 'payout') {
        if (item.d.c === 'success') item.type = 'payout-success'
        else if (item.d.c === 'processing') item.type = 'payout-processing'
        else if (item.d.c === 'pending') item.type = 'payout-pending'
        else if (item.d.c === 'error') item.type = 'payout-error'
        item.amount = item.d.a
      }

      delete item.d

      item.coin = vm.coin
      item.icon = vm.dictionary[item.type].icon
      item.iconColor = vm.dictionary[item.type].iconColor
      item.timestamp = item.t
      item.updated = true
      if (item.algorithm) item.algorithm = item.algorithm.substring(0, 1).toUpperCase() + item.algorithm.substring(1, item.algorithm.length)
      item.description = vm.dictionary[item.type].template.replace(/\{\{(\w+)\}\}/g, function (_, key) {
        return item[key];
      });

      return item
    },
    goToEvent(o) {
      let vm = this
      if (o.type.startsWith('worker')) {
        vm.$emit('goToTab', 'workers')
      } else if (o.type.startsWith('payout')) {
        vm.$emit('goToTab', 'payments')
      }
    },
    loadMoreEvents() {
      let vm = this
      vm.page++
      let eventContainer = document.getElementById('event-container')
      vm.containerHeight = eventContainer.offsetHeight
      vm.infiniteScroll = true
      vm.fetch(true, function () {
        vm.fetch(false)
      })
    },
    selectTypeFilter(o) {
      let vm = this
      o.selected = !o.selected

      this.$nextTick(() => {
        let filterTypeCodesSelected = vm.filterTypes.filter(o => o.selected).map(o => o.code)
        if (filterTypeCodesSelected) vm.$store.dispatch('setLiveFilter', filterTypeCodesSelected)
        else vm.$store.dispatch('setLiveFilter', [])
        vm.fetch(true)
      })
    },
    reprintShadowScroll(e) {
      let vm = this
      let container = document.getElementById('event-container')

      vm.isMobile = window.innerWidth <= 768

      if (!vm.isMobile) {
        if (!container || container.clientHeight === 0) {
          setTimeout(function () {
            vm.reprintShadowScroll()
          }, 100)
        } else {
          if (container.scrollHeight - container.clientHeight === 0) {
            // There is no scroll
            vm.showTopShadow = false
            vm.showBottomShadow = false
          } else {
            if (container.scrollTop !== 0) vm.showTopShadow = true
            else vm.showTopShadow = false

            if ((container.scrollHeight - container.clientHeight) - container.scrollTop < 1.1) {
              vm.showBottomShadow = false
              if (!vm.noMoreFetch) vm.fetch(false)
            } else {
              vm.showBottomShadow = true
            }
          }
        }
      } else {
        vm.showTopShadow = false
        vm.showBottomShadow = false
      }
    },
    doScroll(direction, amount) {
      let vm = this

      if (vm.isHoveringTop && vm.isHoveringBottom) {
        if (direction === 'top') vm.isHoveringBottom = false
        if (direction === 'bottom') vm.isHoveringTop = false
      }

      let container = document.getElementById('event-container')

      if (container.scrollTop === 0) {
        vm.isHoveringTop = false
      } else if ((container.scrollHeight - container.clientHeight) - container.scrollTop < 1.1) {
        vm.isHoveringBottom = false
      }

      if (vm.isHoveringTop || vm.isHoveringBottom) {
        let topScroll = container.scrollTop
        if (direction === 'top') topScroll = container.scrollTop - amount
        else topScroll = container.scrollTop + amount

        if (topScroll < 0) topScroll = 0

        container.scrollTo({
          top: topScroll,
          left: 0,
          behavior: 'smooth'
        })

        setTimeout(function () {
          if (vm.isHoveringTop && vm.isHoveringBottom) {
            if (direction === 'top') vm.isHoveringBottom = false
            if (direction === 'bottom') vm.isHoveringTop = false
          }
          if (vm.isHoveringTop && direction === 'top') vm.doScroll(direction, amount)
          if (vm.isHoveringBottom && direction === 'bottom') vm.doScroll(direction, amount)
        }, 50)
      }
    },
    isTouchEvent() {
      return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    },
    checkMobileBottomScroll() {
      let vm = this
      if (vm.isMobile && !vm.noMoreFetch && vm.infiniteScroll) {
        let container = document.documentElement
        if (container.scrollHeight - container.clientHeight === 0) {
          // There is no scroll
        } else {
          if ((container.scrollHeight - container.clientHeight) - container.scrollTop < 1.1) {
            if (!vm.isLoading) vm.fetch(false)
          } else {
          }
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.amount-large
  font-weight: 700;
  font-size 16px
  line-height 21px
  span, img
    vertical-align middle
  img
    width 15px
.extended_amount
  color #bababa
.padding-no-results
  padding: 0px 0px 25px 10px
.events-super-container
  position relative
.infinite-container
  overflow-y: auto
.event-container
  scrollbar-width: none;
.event-container::-webkit-scrollbar
  display none

.live-list
  padding-bottom: 2px
  .live-item
    display: flex;
    align-items: center
    border-top: 1px solid #dbdbdb;
    padding: 0.75rem 15px

    &:first-child
      border-top: 1px transparent solid;
      padding-top: 7px

    .live-icon
      font-size: 20px; 
      text-align: right; 
      width: 20px; 
      padding: 0px 30px 0px 15px;
      display: flex;
      justify-content: center;
      align-items: center;
    .live-description
      flex: 1;
      text-align: left;
      font-size: 13px
    .live-external-link
      font-size: 20px; 
      text-align: center;
      cursor pointer
      i
        color: #919191;

.more-events
  padding 20px 0px
  .more-events-subtitle
    font-size 10px
.is-loading
  padding 20px 0px
.box-shadow-container
  width 100%
  height 20px
  position absolute
  z-index: 10;
  display flex
  align-items center
  padding 5px
  cursor pointer
  -webkit-tap-highlight-color: transparent;
  &.top
    top 0px
    left 0px
    box-shadow: inset 0px 10px 14px -13px #000;
  &.bottom
    bottom 0px
    left 0px
    box-shadow: inset 0px -10px 14px -13px #000;

.filter-type
  text-align left
  margin-bottom: 16px;
  .title-tag
    font-size 0.8rem
    padding-top 4px
  .tag
    font-size 0.7rem
    cursor pointer
    margin-left 5px
    color: #717171
    background-color transparent
    border-color: #e5e5e5;
    border-style: solid;
    border-width: 1px;
    user-select: none;
    &.selected
      border-color: #717171;
      font-weight 400

html.dark, body.dark
  .box-shadow-container
    &.top
      box-shadow: inset 0px 10px 13px -13px #fff;
    &.bottom
      box-shadow: inset 0px -10px 13px -13px #fff;
  .filter-type
    .title-tag
      color #fff
    .tag
      color #fff
      &.selected
        color #000
        background-color #fff
        border-color #fff

</style>



// WEBPACK FOOTER //
// c_tab_live_events.vue?86542184